import React, { Fragment } from "react";
import DevelopmentCard from "@/atoms/DevelopmentCard";
import { DevelopmentCardData, DevelopmentRibbonType } from "@/atoms/DevelopmentCard/types";
import { useGetHomepageDevelopmentsQuery } from "@/services/cms/queries";
import { Development } from "@/services/cms/apiTypes";
import getConfig from "next/config";

const hardcodedDevelopments: DevelopmentCardData[] = [
  {
    image: "/developments/southall.jpg",
    location: "Southall, UB3",
    name: "The Green Quarter",
    description: "Modern living with gym, co-working space and more with Elizabeth Line access",
    homesAvailable: 4,
    href: "/properties/southall",
  },
  {
    image: "/developments/harrow.jpg",
    location: "Harrow, HA1",
    name: "Eastman Village",
    description:
      "Harrow's newest neighbourhood with on-site concierge, gym and 6 acres of greenery.",
    homesAvailable: 2,
    ribbon: "onlyTwoLeft",
    href: "/properties/harrow",
  },
  {
    image: "/developments/hayes.jpg",
    location: "Hayes, UB3",
    name: "Hayes Village",
    description:
      "Stylish 2 bedroom homes in a waterside setting within a few minutes walk to Elizabeth Line",
    homesAvailable: 5,
    href: "/properties/hayes",
  },
  {
    image: "/developments/wandsworth.jpg",
    location: "Wandsworth, SW17",
    name: "Springfield Village",
    description:
      "Experience modern elegance right on the Springfield Park with 1 & 2 bed homes – available from July",
    homesAvailable: null,
    ribbon: "comingSoon",
    href: "/properties/wandsworth",
  },
];

const toDevelopmentCard = (dev: Development): DevelopmentCardData => {
  const attrs = dev.attributes;
  const slug = attrs.neighbourhood?.data?.attributes?.slug;
  const coverUrl = attrs.cover?.data?.attributes?.url ?? "";

  let homesAvailable: number | null = null;
  let ribbon: DevelopmentRibbonType | undefined;

  if (attrs.isUpcomingProject) {
    ribbon = "comingSoon";
  } else {
    const listings = attrs.neighbourhood?.data?.attributes?.listings?.data ?? [];
    const availableCount = listings.filter(
      (l) =>
        l.attributes.ribbonType !== "comingSoon" &&
        l.attributes.ribbonType !== "reserved" &&
        l.attributes.ribbonType !== "let",
    ).length;

    homesAvailable = availableCount;

    if (availableCount === 0) ribbon = "soldOut";
    else if (availableCount === 1) ribbon = "lastUnit";
    else if (availableCount === 2) ribbon = "onlyTwoLeft";
    else if (availableCount === 3) ribbon = "onlyThreeLeft";
  }

  return {
    image: coverUrl,
    location: attrs.dropdownHeading ?? "",
    name: attrs.developmentName ?? attrs.title ?? "",
    description: attrs.description ?? "",
    homesAvailable,
    ...(ribbon ? { ribbon } : {}),
    href: slug ? `/properties/${slug}` : "/",
  };
};

const LiveKeyzyDevelopments = () => {
  const { publicRuntimeConfig } = getConfig();
  const useCms = publicRuntimeConfig.NEXT_USE_CMS_FOR_LANDING_DEVELOPMENTS === "1";
  const { data: cmsData } = useGetHomepageDevelopmentsQuery();

  const tiles: DevelopmentCardData[] = useCms
    ? cmsData?.map(toDevelopmentCard) || []
    : hardcodedDevelopments;

  const tileWidthClass = tiles.length <= 3 ? "lg:w-1/3" : "lg:w-1/4";
  const justifyClass = tiles.length <= 3 ? "justify-center" : "justify-start";

  return (
    <div className="relative h-full bg-landing-ivory w-full overflow-hidden mb-9 md:mb-0">
      {/* <div className="relative h-full bg-white w-full overflow-hidden mb-9 md:mb-0">
        <div className="flex w-full left-0 right-0 overflow-hidden bg-repeat-x mt-4 lg:mt-7 h-24 md:h-52 xl:h-48 bg-[url('/intermediaries/city-outline-mobile.svg')] md:bg-[url('/intermediaries/city-outline-tablet.svg')] xl:bg-[url('/intermediaries/city-outline-desktop.svg')]" />
      </div> */}
      <h2 className="text-4xl mx-5 font-bold lg:text-5xl text-landing-blue text-center mt-4 md:mt-14">
        Live Keyzy developments
      </h2>
      <h3 className="mx-5 text-2xl font-serif lg:text-3xl text-landing-blue text-center my-6">
        Hand-picked rent-to-buy neighbourhoods across London. Tap through to see every home in each.
      </h3>
      <section
        className={`flex flex-wrap items-stretch w-auto mt-9 max-w-[90rem] mb-5 md:mb-12 mx-auto lg:px-[1.5rem] bg-landing-ivory ${justifyClass}`}
      >
        {tiles.map((development, idx) => (
          <Fragment key={idx}>
            <div className={`flex flex-col w-full sm:w-1/2 mb-8 px-5 md:px-4 ${tileWidthClass}`}>
              <DevelopmentCard development={development} />
            </div>
          </Fragment>
        ))}
      </section>
    </div>
  );
};

export default LiveKeyzyDevelopments;
